import ForeignVatSetting from "@/module/Form/ForeignVatProvider/ForeignVatSetting";
import { ForeignVatType } from "@/module/Form/ForeignVatProvider/ForeignVatType";

export default class ForeignVatProvider {
  private readonly foreignVatSetting: ForeignVatSetting[];

  constructor(foreignVatSetting: ForeignVatSetting[]) {
    this.foreignVatSetting = foreignVatSetting;
  }

  findVat(country: string, type: ForeignVatType): number | null {
    let foreignVatSetting = this.foreignVatSetting.find(
      (item: ForeignVatSetting) => {
        return item.country === country && item.type === type;
      },
    );

    if (foreignVatSetting !== undefined) {
      return foreignVatSetting.vat;
    }

    foreignVatSetting = this.foreignVatSetting.find(
      (item: ForeignVatSetting) => {
        return (
          item.country === country &&
          item.type === ForeignVatType.ELECTRONIC_SERVICE
        );
      },
    );

    if (foreignVatSetting !== undefined) {
      return foreignVatSetting.vat;
    }

    return null;
  }
}
